import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit/src/mapBuilders";
import { NoInfer } from "@reduxjs/toolkit/src/tsHelpers";
import { setUser } from "../../common/user";
import { overviewService } from "../../../services/agent/overview.service";
import { setGeneralProgressHide, setGeneralProgressShow } from "../../common/ui";

export type overviewSliceState = {
  overview: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
};

const initialState: overviewSliceState = {
  overview: {
    data: null,
    error: null,
    isFetching: false,
  },
};

export const getOverviewData: any = createAsyncThunk(
  'agentOverview/getOverviewData',
  async (payload: any, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await overviewService.getOverview(payload);
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());

      return data;
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);

export const agentOverviewSlice = createSlice({
  name: 'agentOverview',
  initialState: initialState,
  reducers: {
    clearOverviewState(state) {
      state.overview.error = null;
      state.overview.isFetching = false;
      state.overview.data = null;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<overviewSliceState>>) => {
    builder.addCase(getOverviewData.pending, (state) => {
      state.overview.isFetching = true;
      state.overview.error = null;
    });
    builder.addCase(getOverviewData.fulfilled, (state, action) => {
      state.overview.error = null;
      state.overview.isFetching = false;
      state.overview.data = action.payload;
    });
    builder.addCase(getOverviewData.rejected, (state, action) => {
      state.overview.isFetching = false;
      state.overview.error = action.payload;
      state.overview.data = null;
    });
  },
});

export const {
  clearOverviewState,
} = agentOverviewSlice.actions;

export default agentOverviewSlice.reducer;
